// extracted by mini-css-extract-plugin
export var borderRadius = "_h2-4";
export var large = "_h2-3";
export var logoContainer = "_h2-0";
export var nameLogo = "_h2-2";
export var small = "_h2-1";